/**
 * Fakturierung
 * API für Fakturierung
 *
 * The version of the OpenAPI document: 1.7.0-FEATURE-scj-xrechnung-behoerde-SNAPSHOT
 * Contact: support@landdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class BelegContentService {

    protected basePath = 'https://api.adnova.de/fakturierung-service';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Abrufen der Belegdatei (PDF oder XRechnung-XML).
     * Ruft die Belegdatei zum Beleg ab (PDF oder XRechnung-XML, siehe &#x60;belegformat&#x60; am Beleg). Existiert nur, wenn der Beleg min. fertiggestellt ist. 
     * @param betriebId Id die einen Betrieb identifiziert. 
     * @param belegId Id die einen Beleg identifiziert. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadBelegPdfContent(betriebId: string, belegId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/xml'}): Observable<Blob>;
    public downloadBelegPdfContent(betriebId: string, belegId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/xml'}): Observable<HttpResponse<Blob>>;
    public downloadBelegPdfContent(betriebId: string, belegId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/xml'}): Observable<HttpEvent<Blob>>;
    public downloadBelegPdfContent(betriebId: string, belegId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/xml'}): Observable<any> {
        if (betriebId === null || betriebId === undefined) {
            throw new Error('Required parameter betriebId was null or undefined when calling downloadBelegPdfContent.');
        }
        if (belegId === null || belegId === undefined) {
            throw new Error('Required parameter belegId was null or undefined when calling downloadBelegPdfContent.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth-ld) required
        credential = this.configuration.lookupCredential('oauth-ld');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf',
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/v1/betriebe/${encodeURIComponent(String(betriebId))}/belege/${encodeURIComponent(String(belegId))}/content/pdf`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Abrufen der PDF-Darstellung der Belegdatei.
     * Liefert die Belegdatei als PDF zur Anzeige. Bei XRechnung-Belegen (&#x60;belegformat&#x60; &#x3D; &#x60;XRECHNUNG&#x60;) wird das XML serverseitig als PDF visualisiert; die Visualisierung ist nur eine Ansicht, die Belegdatei selbst bleibt das XML (&#x60;.../content/pdf&#x60;). Bei PDF-Belegen wird die gespeicherte PDF-Datei geliefert. Existiert nur, wenn der Beleg min. fertiggestellt ist. 
     * @param betriebId Id die einen Betrieb identifiziert. 
     * @param belegId Id die einen Beleg identifiziert. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadBelegVisualisierung(betriebId: string, belegId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<Blob>;
    public downloadBelegVisualisierung(betriebId: string, belegId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<HttpResponse<Blob>>;
    public downloadBelegVisualisierung(betriebId: string, belegId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<HttpEvent<Blob>>;
    public downloadBelegVisualisierung(betriebId: string, belegId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<any> {
        if (betriebId === null || betriebId === undefined) {
            throw new Error('Required parameter betriebId was null or undefined when calling downloadBelegVisualisierung.');
        }
        if (belegId === null || belegId === undefined) {
            throw new Error('Required parameter belegId was null or undefined when calling downloadBelegVisualisierung.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth-ld) required
        credential = this.configuration.lookupCredential('oauth-ld');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/v1/betriebe/${encodeURIComponent(String(betriebId))}/belege/${encodeURIComponent(String(belegId))}/content/visualisierung`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
